<div class="outline-field">
  <ng-content></ng-content>
</div>
